import { useForm } from "react-hook-form";
import { AccordionTemplate } from "../../../ui/organisms/accordionTemplate";
import { CustomMailDTO } from "./dto";
import { TemplateFormValues, templateSchema } from "./validation";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useState } from "react";
import { useUpdateEmailMutation } from "../../../../features/mailsApi";
import { useAppDispatch } from "../../../lib/redux/hooks";
import { addBannerWithTimeout } from "../../../lib/centralizedBanner/slice";
import Input from "../../../ui/molecules/input";
import Button from "../../../ui/molecules/button";
import Tiptap from "../../../ui/molecules/editorInput/tiptap";
import { translateVariables, variablesMap } from "./utils";

export function TemplateDetails({ template, setIdToDelete }: { template: CustomMailDTO, setIdToDelete: React.Dispatch<React.SetStateAction<string | null>> }) {
    const dispatch = useAppDispatch()
    const [openTemplate, setOpenTemplate] = useState(false)

    const editForm = useForm<TemplateFormValues>({
        resolver: zodResolver(templateSchema),
    })

    useEffect(() => {
        if (template && template.fromEmail && template.fromEmailName) {
            editForm.reset({
                fromEmail: template.fromEmail,
                fromEmailName: template.fromEmailName,
                projectId: template.projectId,
                templateName: template.templateName,
                subject: template.subject,
                templateText: template.templateText,
                templateHTML: template.templateHTML,
            })
        }
    }, [template])

    const [updateEmail] = useUpdateEmailMutation()
    const handleCreateCustomMail = async () => {
        try {
            await updateEmail({ data: editForm.getValues(), id: template.id }).unwrap()
            dispatch(addBannerWithTimeout({ message: "Email personalizzata aggiornata con successo", variant: "success" }))
        } catch (error) {
            let message = "Errore durante la modifica dell'email personalizzata"
            const _error = error as { status: number, data: string }
            if (_error.data === 'subject already exists') {
                message = "Esiste già un template con questo oggetto"
            }
            dispatch(addBannerWithTimeout({ message, variant: "error" }))
        }
    }
    return (
        <AccordionTemplate
            open={openTemplate}
            onClick={() => {
                setOpenTemplate(prev => !prev)
                editForm.reset({
                    ...editForm.getValues(),
                    templateName: template.templateName,
                    subject: template.subject,
                })
            }}
            deleteFunc={() => setIdToDelete(template.id)}
            title={template.templateName}
            content={
                <div className='flex flex-col gap-6 p-4'>
                    <div className='flex flex-col gap-3'>
                        <Input
                            label='Nome template'
                            value={editForm.watch('templateName')}
                            onChangeText={e => editForm.setValue('templateName', e)}
                            placeholder="Specificare il nome del template"
                        />
                    </div>
                    <div className='flex flex-col gap-3'>
                        <Input
                            label='Oggetto'
                            value={editForm.watch('subject')}
                            onChangeText={e => editForm.setValue('subject', e)}
                            placeholder="Specificare l'oggetto della mail"
                        />
                    </div>
                    <div className='flex flex-col gap-11'>
                        {/* <EditorInput
                            label='Contenuto della mail'
                            html={editTemplateText === "" ? translateVariables(item.templateHTML) : editTemplateText}
                            placeholder="Descrivere il contenuto dell'e-mail"
                            id='input-editor-settings-email-edit'
                            key='input-editor-settings-email-edit'
                            onChangeHtml={e => console.log(e)}
                            onChangeText={e => console.log(e)}
                            // onChangeText={(e) => {
                            //     const parser = new DOMParser();
                            //     const doc = parser.parseFromString(e, "text/html");

                            //     const links = doc.querySelectorAll("a");

                            //     if (links.length > 0) {
                            //         links.forEach((link) => {
                            //             let href = link.getAttribute("href");

                            //             if (href && !href.startsWith("http://") && !href.startsWith("https://")) {
                            //                 link.setAttribute("href", `https://${href}`);
                            //             }
                            //         });

                            //         setEditTemplateText(doc.body.innerHTML);
                            //     } else {
                            //         setEditTemplateText(e);
                            //     }
                            // }}
                            ref={quillRef}
                        /> */}
                        <Tiptap
                            label="Contenuto della mail"
                            onChangeHtml={(e) => editForm.setValue('templateHTML', e)}
                            onChangeText={e => editForm.setValue('templateText', e)}
                            content={translateVariables(editForm.watch('templateHTML'))}
                            variables={Array.from(variablesMap.entries()).map(([key, value]) => ({ label: key, value }))}
                        />
                        {
                            editForm.formState.errors.templateText &&
                            <span className=' text-text-xs text-red-600'>
                                {editForm.formState.errors.templateText.message}
                            </span>
                        }
                        {/* <div ref={buttonRef} className='flex flex-col items-end justify-center'>
                            <Button
                                onClick={() => setOpenVariables(prev => !prev)}
                                label="Inserisci una variabile"
                                size={'sm'}
                                iconPosition={'left'}
                                variant={'link'}
                                color={'blue'}
                            />
                            {ReactDOM.createPortal((
                                openVariables ?
                                    <div ref={menuRef} className="bg-white border-[1px] border-neutral-100 rounded-md absolute shadow-sm z-[100]"
                                        style={{
                                            top: buttonRef.current ? (buttonRef.current.getBoundingClientRect().top + 40) : 0,
                                            right: buttonRef.current ? buttonRef.current.getBoundingClientRect().left : 0,
                                        }}
                                    >
                                        {variableOptions}
                                    </div> : null
                            ), document.body)}
                        </div> */}
                    </div>
                    <Button
                        onClick={() => {
                            // editForm.setValue("templateText", stripHtml(editTemplateText)[0])
                            // editForm.setValue("templateHTML", updateTemplate(editTemplateText)[1])
                            editForm.handleSubmit(handleCreateCustomMail)()
                        }}
                        label="Salva modifiche"
                        size={'sm'}
                        iconPosition='left'
                        variant='solid'
                        color='blue'
                    />
                </div>
            } />
    )
}